import pageLoadConstants from '../constants/pageLoad.constant';
import CachedDataService from './CachedDataService';

declare global {
  interface Window {
    webAnalytics: any;
  }
}
export default class PageLoadDataService {
  public static buildPageName(_data): string {
    const pageId = PageLoadDataService.extractPageId(window.location.href);
    const domain = window.location.hostname.split('.')[0];
    let pageName = `${pageLoadConstants.countryCode}:${pageLoadConstants.language}:${pageLoadConstants.siteIdentifier}:${pageLoadConstants.platform}`;
    if (domain && !domain.includes('www')) {
      pageName += `:${domain}`;
    }
    if (pageId) {
      pageName += `:${pageId}`;
    }

    return pageName;
  }

  public static extractPageId(href): string {
    const anchor = document.createElement('a');
    let pageId;
    const blacklist = [
      '',
      'en',
      'us',
      'vanguard',
      'jsp',
      'web',
      'xhtml',
      'content',
      'faces',
      'com',
      'external',
      'retail',
      'si',
      'regis',
      'util',
      'static',
      'pages',
      'sitewide',
      'other',
      'cbd',
      'data',
      'hnwnesc',
      'commonauth',
    ];

    anchor.href = href;
    pageId = anchor.pathname.toLowerCase().split('/');

    // Remove any indexes from array that contain values that are black-listed
    PageLoadDataService.filterArray(pageId, (item) => PageLoadDataService.indexOf(blacklist, item) === -1);

    // Remove any file extensions from last item in pageId array
    if (pageId.length > 0) {
      pageId[pageId.length - 1] = pageId[pageId.length - 1].split('.')[0];
    }
    return pageId.join(':');
  }

  public static filterArray(array, func): any {
    let index = array.length;
    while (index--) {
      if (!func(array[index])) {
        array.splice(index, 1);
      }
    }
  }

  public static indexOf(obj, value): any {
    let index = obj.length;
    if (obj.indexOf) {
      index = obj.indexOf(value);
    } else {
      while (index--) {
        if (obj[index] === value) {
          break;
        }
      }
    }
    return index;
  }

  public static buildPublicVsSecure() {
    const isUserLoggedIn = Boolean(CachedDataService.get().uid);
    let publicVsSecure = pageLoadConstants.publicVsSecure;
    if (isUserLoggedIn) {
      publicVsSecure = 'secure';
    }
    return publicVsSecure;
  }

  public static buildPageData(data): object {
    const wA = window.webAnalytics || {};
    wA.page_data = wA.page_data || {};
    wA.event_data = wA.event_data || {};
    wA.dfa_data = wA.dfa_data || {};
    wA.context_data = wA.context_data || {};
    wA.config_data = wA.config_data || {};
    wA.reserved_data = wA.reserved_data || {};
    window.webAnalytics = wA;

    const blacklist = [
      '',
      'us',
      'vanguard',
      'jsp',
      'web',
      'xhtml',
      'content',
      'faces',
      'com',
      'external',
      'retail',
      'si',
      'regis',
      'util',
      'static',
      'pages',
      'sitewide',
      'other',
      'cbd',
      'data',
      'hnwnesc',
      'commonauth',
    ];

    const extractSiteSections = window.location.pathname.toLowerCase().split('/');
    PageLoadDataService.filterArray(extractSiteSections, (item) => PageLoadDataService.indexOf(blacklist, item) === -1);

    return {
      DLVersion: pageLoadConstants.DLVersion,
      is404: data.is404 || pageLoadConstants.is404,
      pageName: PageLoadDataService.buildPageName(data),
      pageTemplate: data.pageTemplate,
      pageTitle: document.title,
      platform: window.webAnalytics.config_data.platform || pageLoadConstants.platform,
      publicVsSecure: PageLoadDataService.buildPublicVsSecure(),
      siteIdentifier: window.webAnalytics.config_data.siteIdentifier || pageLoadConstants.siteIdentifier,
      siteSection1: data.siteSection1 || extractSiteSections[0],
      siteSection2: data.siteSection2 || extractSiteSections[1] || 'none',
    };
  }
}
